export const CHANGE_PRESET_RAS = 'CHANGE_PRESET_RAS';
export const EDIT_ALTURA_PROJECT_NUMBER = 'EDIT_ALTURA_PROJECT_NUMBER';
export const EDIT_LICENSE_NUMBER = 'EDIT_LICENSE_NUMBER';
export const EDIT_EAB_PROJECT_NUMBER = 'EDIT_EAB_PROJECT_NUMBER';
export const EDIT_PROJECT_NAME = 'EDIT_PROJECT_NAME';
export const EDIT_PROJECT_DESCRIPTION = 'EDIT_PROJECT_DESCRIPTION';
export const EDIT_PROJECT_SCOPE = 'EDIT_PROJECT_SCOPE';
export const EDIT_PROJECT_FACILITY = 'EDIT_PROJECT_FACILITY';
export const EDIT_PROJECT_ADDRESS = 'EDIT_PROJECT_ADDRESS';
export const EDIT_PROJECT_ADDRESS_2 = 'EDIT_PROJECT_ADDRESS_2';
export const EDIT_OWNER_CONTACT_NAME = 'EDIT_OWNER_CONTACT_NAME';
export const EDIT_OWNER_NAME = 'EDIT_OWNER_NAME';
export const EDIT_OWNER_ADDRESS = 'EDIT_OWNER_ADDRESS';
export const EDIT_OWNER_ADDRESS_2 = 'EDIT_OWNER_ADDRESS_2';
export const EDIT_RAS_EMAIL = 'EDIT_RAS_EMAIL';
export const EDIT_RAS_NAME = 'EDIT_RAS_NAME';
export const RECEIVE_FIELDS = 'RECEIVE_FIELDS';
export const SAVE_FIELDS = 'SAVE_FIELDS';
export const FETCH_RAS_INFO = 'FETCH_RAS_INFO';
export const RECEIVE_RAS_INFO = 'RECEIVE_RAS_INFO';
export const SET_FIELD_ERRORS = 'SET_FIELD_ERRORS';